import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-25082">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-25083">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25084">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Политика конфиденциальности'
        }]} className="mb-8" data-id="element-25085" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-25086">
            Политика конфиденциальности
          </h1>
          <p className="text-slate-500" data-id="element-25087">Последнее обновление: 15 мая 2026 г.</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-25088">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-25089">
          <h2 data-id="element-25090">1. Общие положения</h2>
          <p data-id="element-25091">
            Настоящая Политика конфиденциальности (далее — «Политика»)
            определяет порядок обработки и защиты персональных данных
            пользователей сервиса Astriqo (далее — «Сервис»). Мы с уважением
            относимся к конфиденциальности ваших данных и прилагаем все усилия
            для их защиты.
          </p>

          <h2 data-id="element-25092">2. Какие данные мы собираем</h2>
          <p data-id="element-25093">
            Для предоставления астрологических услуг мы собираем следующие
            данные:
          </p>
          <ul data-id="element-25094">
            <li data-id="element-25095">
              <strong data-id="element-25096">Регистрационные данные:</strong> имя, адрес электронной
              почты, номер телефона.
            </li>
            <li data-id="element-25097">
              <strong data-id="element-25098">Астрологические данные:</strong> дата, точное время и
              место рождения (необходимы для расчета натальной карты).
            </li>
            <li data-id="element-25099">
              <strong data-id="element-25100">Технические данные:</strong> IP-адрес, тип браузера,
              данные файлов cookie.
            </li>
          </ul>

          <h2 data-id="element-25101">3. Использование данных</h2>
          <p data-id="element-25102">Мы используем ваши данные исключительно для следующих целей:</p>
          <ul data-id="element-25103">
            <li data-id="element-25104">Генерация персональных астрологических отчетов.</li>
            <li data-id="element-25105">Организация консультаций с астрологами платформы.</li>
            <li data-id="element-25106">Улучшение качества работы Сервиса.</li>
            <li data-id="element-25107">
              Отправка важных уведомлений (например, о готовности отчета).
            </li>
          </ul>

          <h2 data-id="element-25108">4. Передача данных третьим лицам</h2>
          <p data-id="element-25109">
            Мы не продаем и не передаем ваши персональные данные третьим лицам
            для маркетинговых целей. Ваши астрологические данные (дата, время,
            место рождения) могут быть переданы выбранному вами астрологу
            исключительно для проведения оплаченной консультации.
          </p>

          <h2 data-id="element-25110">5. Безопасность данных</h2>
          <p data-id="element-25111">
            Мы используем современные методы шифрования и защиты данных для
            предотвращения несанкционированного доступа. Все платежи
            обрабатываются через защищенные шлюзы сертифицированных платежных
            систем.
          </p>

          <h2 data-id="element-25112">6. Ваши права</h2>
          <p data-id="element-25113">Вы имеете право в любой момент:</p>
          <ul data-id="element-25114">
            <li data-id="element-25115">Запросить копию всех ваших данных, хранящихся в Сервисе.</li>
            <li data-id="element-25116">
              Отредактировать или удалить свои данные через настройки Личного
              кабинета.
            </li>
            <li data-id="element-25117">Отозвать согласие на обработку персональных данных.</li>
          </ul>

          <h2 data-id="element-25118">7. Контакты</h2>
          <p data-id="element-25119">
            Если у вас есть вопросы по поводу настоящей Политики
            конфиденциальности, пожалуйста, свяжитесь с нами по адресу:{' '}
            <a href="mailto:privacy@astriqo.com" data-id="element-25120">privacy@astriqo.com</a>.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-25121">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-25122">
            Пользовательское соглашение →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-25123">
            Есть вопросы? Свяжитесь с нами
          </button>
        </div>
      </div>
    </div>;
}